<template>
  <base-filter v-on:clear="clear"
               v-on:remove="remove">
    <template v-slot:filter>
      <b-form-tags :input-id="inputId"
                   v-model="value"
                   tag-variant="primary"
                   tag-pills
                   size="md"
                   separator=" ,;"
                   remove-on-delete
                   :placeholder="placeholder"
                   invalid-tag-text="Invalid Value(s)"
                   duplicate-tag-text="Duplicate Value(s)"
                   :tag-validator="validator"/>
    </template>
  </base-filter>

</template>

<script lang="ts">
import {defineComponent} from "vue";
import BaseFilter from '@/views/stats/facebook/filters/dynamic/BaseFilter.vue';
import {mapGetters, mapMutations} from "vuex";
import {FilterItemPayload} from "@/store/modules/stats/facebook/state/scopeDynamicFilters";
export default defineComponent({
  name: "StringsFilter",

  props: {
    filterKey: {
      type: String,
      required: true,
    },
  },

  components: {
    BaseFilter
  },

  computed: {
    ...mapGetters({
      scopeFilters: 'stats/facebook/scopeFilters',
    }),

    filter():FilterItemPayload {
      return this.scopeFilters.find(filter => filter.key === this.filterKey);
    },

    value: {
      get(): string {
        return this.filter.value ?? [];
      },
      set(value) {
        this.setScopeFilter({
          key: this.filter.key,
          value: value
        });
      }
    },

    placeholder() {
      return this.filter.settings?.gui?.inputPlaceholder ?? 'Value';
    },

    inputId() {
      return this.filter.key;
    },
  },

  methods: {
    ...mapMutations({
      setScopeFilter: 'stats/facebook/setScopeFilter',
      removeScopeFilter: 'stats/facebook/removeScopeFilter',
    }),
    clear() {
      this.setScopeFilter({key: this.filterKey, value: null});
    },
    remove() {
      this.removeScopeFilter(this.filterKey);
    },

    validator(value) {
      return value.trim() != '';
    }
  }
});
</script>

<style scoped>

</style>